import React from "react";
import { PageWrapper } from "../../Styles/style";
import Section1_Header from "../S1_Header";
import Section2_About from "../S3_Bit";
import About from "../S2_About";
import styled from "@emotion/styled";
import Section6_Footer from "../S7_Footer";
import Swipe from "../../Components/Swipe";
import Dry from "../../Components/Dry";
import up from "../../../assets/images/firstbg.png"
const Div = styled.div`
  min-height: 100vh;
  background-image: url(${up});
  background-size: cover;
  background-position: center center;
`;

const VideoBG = styled.video`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  /* display: block;  */
  /* z-index: 1; */
  @media screen and (max-width:543px) {
    /* display: none; */
  } 
`
const VideoMB = styled.video`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  /* z-index: 1; */
  display: none;
  @media screen and (max-width:543px) {
    display: block;
  }  
`

const MainPage = (props) => {
  return (
    <PageWrapper>
      <Div>
        <Section1_Header />
      </Div>
      <About />
      <Swipe bgcolor="#000" scrollamount="20"/>
      {/* <Swipe bgcolor="#000"  scrollamount="18"/> */}
      <Section2_About />
      <Dry  scrollamount="22"/>
      <Section6_Footer />
    </PageWrapper>
  );
};

export default MainPage;
